import i18next from 'i18next';
import { lazy } from 'react';
import bg from './i18n/bg';
import en from './i18n/en';

i18next.addResourceBundle('bg', 'homePage', bg);
i18next.addResourceBundle('en', 'homePage', en);

const Home = lazy(() => import('./Home'));

/**
 * The Home page config.
 */
const HomeConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: 'home',
			element: <Home />
		}
	]
};

export default HomeConfig;
